import { render, staticRenderFns } from "./addPaymentFee.vue?vue&type=template&id=70e6ccb9&"
import script from "./addPaymentFee.vue?vue&type=script&lang=js&"
export * from "./addPaymentFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports